import { FORMS } from '../models/forms';

function delay(ms = 350) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Todas las plantillas de formularios. */
export async function getForms() {
  await delay();
  return [...FORMS];
}

/** Una plantilla puntual por id (o `null` si no existe). */
export async function getFormById(id) {
  await delay(200);
  return FORMS.find((f) => f.id === id) ?? null;
}

/** Formularios visibles/asignados a un rol específico. */
export async function getFormsForRole(role) {
  await delay();
  return FORMS.filter((f) => f.assignedRoles.includes(role));
}
